import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/play.png';
import _imports_1 from '../../assets/images/mine/share.png';

const _withScopeId = n => (_pushScopeId("data-v-6c22e9b8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "videoMrtj"
};
const _hoisted_2 = {
  class: "head_title"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "每日精选", -1));

const _hoisted_4 = {
  class: "cont webkit-overflow-scrolling-touch"
};
const _hoisted_5 = {
  key: 0,
  class: "title"
};
const _hoisted_6 = {
  class: "video_list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "video_box"
};
const _hoisted_9 = {
  class: "times"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-box-play"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));

const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "user_img"
};
const _hoisted_13 = {
  class: "user_text"
};
const _hoisted_14 = {
  class: "user_title text_ellipsis"
};
const _hoisted_15 = {
  class: "details text_ellipsis"
};
const _hoisted_16 = ["onClick"];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = {
  class: "details_page"
};
const _hoisted_20 = {
  class: "cont_body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_my_image = _resolveComponent("my-image");

  const _component_van_list = _resolveComponent("van-list");

  const _component_video_details = _resolveComponent("video-details");

  const _component_hot_author_info = _resolveComponent("hot-author-info");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"]), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $setup.loading = $event),
    error: $setup.error,
    "onUpdate:error": _cache[1] || (_cache[1] = $event => $setup.error = $event),
    finished: $setup.finished,
    "error-text": "请求失败，点击重新加载",
    "finished-text": "-我也是有底线的-",
    "loading-text": "正在获取数据...",
    onLoad: $setup.onLoad
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoList, item => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: item.id
      }, [item.titleTime ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.titleTime) + "精选 ", 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "video_item",
        onClick: $event => $setup.videoPlay(item)
      }, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_my_image, {
        url: item.image
      }, null, 8, ["url"]), _createElementVNode("span", _hoisted_9, _toDisplayString(item.times), 1), _hoisted_10]), _createElementVNode("div", {
        class: "vider_user",
        onClick: _withModifiers($event => $setup.toAutorDetails(item), ["stop"])
      }, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_my_image, {
        url: item.top_image
      }, null, 8, ["url"])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_15, _toDisplayString(item.nickname || _ctx.username), 1)]), _createElementVNode("div", {
        class: "fenxian",
        onClick: _withModifiers($event => $setup.showShare(item), ["stop"])
      }, _hoisted_18, 8, _hoisted_16)], 8, _hoisted_11)], 8, _hoisted_7)])], 64);
    }), 128))]),
    _: 1
  }, 8, ["loading", "error", "finished", "onLoad"])]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $setup.showDetailsPopul = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [$setup.type === 1 ? (_openBlock(), _createBlock(_component_video_details, {
      key: $setup.videoId,
      onClose: $setup.close1
    }, null, 8, ["onClose"])) : _createCommentVNode("", true), $setup.type === 2 ? (_openBlock(), _createBlock(_component_hot_author_info, {
      key: $setup.videoId,
      onClose: $setup.close1
    }, null, 8, ["onClose"])) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["show"])]);
}